import { IconBase, IconComponent } from './BaseIcon';

export const Resell: IconComponent = (props) => (
  <IconBase {...props} fillRule="evenodd" clipRule="evenodd">
    <path d="M2 11.4v-10h27.59v9.99a4.2 4.2 0 0 1-1.94 3.52v11.4a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V14.97a4.19 4.19 0 0 1-2-3.55Zm25.5-8h-4.38v8a2.19 2.19 0 1 0 4.38 0v-8Zm-6.38 0h-4.37v8a2.19 2.19 0 1 0 4.37 0v-8Zm-6.37 0h-4.38v8a2.19 2.19 0 1 0 4.38 0v-8Zm-6.38 0H4v8a2.19 2.19 0 1 0 4.37 0v-8Zm16.9 23.65a1 1 0 0 0 .29-.7l-.03-10.8h-.25a4.17 4.17 0 0 1-3.19-1.5 4.13 4.13 0 0 1-6.37 0 4.14 4.14 0 0 1-6.38 0 4.16 4.16 0 0 1-3.19 1.5h-.2v10.8a1 1 0 0 0 1 1h17.61a1 1 0 0 0 .7-.3ZM23.67 25H8v-7h15.67v7Zm-2-5H10v3h11.67v-3Z" />
  </IconBase>
);
